import { createSelector } from 'reselect';

import {
  getApplyRewardsFailedSelector,
  getRemoveRewardsFailedSelector,
  getRewardsSelector,
  getRewardApplicableSelector,
  getPromoCodeAppliedSelector,
  getApplyRewardsApiCallActiveSelector,
  getRemoveRewardsApiCallActiveSelector,
  getRewardsDiscountTotalSelector,
} from '@redux/reducers/order-form/orderFormSelector';

const rewardsState = createSelector(
  [
    getApplyRewardsFailedSelector,
    getRemoveRewardsFailedSelector,
    getRewardsSelector,
    getRewardApplicableSelector,
    getPromoCodeAppliedSelector,
    getApplyRewardsApiCallActiveSelector,
    getRemoveRewardsApiCallActiveSelector,
    getRewardsDiscountTotalSelector,
  ],
  (
    applyRewardsFailed,
    removeRewardsFailed,
    rewards,
    rewardApplicable,
    promoCodeApplied,
    applyRewardsApiCallActive,
    removeRewardsApiCallActive,
    rewardsDiscountTotal,
  ) => {
    const shouldShowWarningOnApply = promoCodeApplied && !promoCodeApplied.isRemoved;

    return {
      disabled: !!(applyRewardsApiCallActive || removeRewardsApiCallActive),
      rewards,
      rewardApplicable,
      rewardsDiscountTotal,
      shouldShowWarningOnApply,
      showErrorMessage: !!(applyRewardsFailed || removeRewardsFailed),
    };
  },
);

export default rewardsState;
